
import { FormControl, FormControlLabel, FormHelperText, Grid, Radio, RadioGroup, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { useDrawsStore } from "../hooks";
import { useEffect } from "react";

const PreferredProcessContent = observer(({ classes, shouldDisabledSnap }) => {
  const { pointOfContactStore } = useDrawsStore();
  const formFields = pointOfContactStore.pointOfContactFormStore.form.fields;
  const error = formFields.inspectionProcess.error;

  const handleFormChange = (e) => {
    pointOfContactStore.pointOfContactFormStore.onFieldChange('inspectionProcess', e.target.value);
    pointOfContactStore.pointOfContactFormStore.onFieldChange('addPointOfContact', 'Y');
    pointOfContactStore.setShowAllFormValues();
  }
  useEffect(() => {
    pointOfContactStore.setShowAllFormValues();
  }, []);

  return (
    <Grid item container xs={12} md={12} className={classes}>
      <Grid container direction="column" item>
        <Grid item container direction='row' justifyContent='space-between'>
          <Grid item>
            <Typography variant="h6">
              SELECT PREFERED 'INSPECTION PROCESS'
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant="caption" color="textSecondary">
            Select your preferred inspection process.
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="column">
        <Grid item xs={12} sm={12}>
          <FormControl component="fieldset"  error={!!error}>
            <RadioGroup value={formFields.inspectionProcess.value} onChange={e => handleFormChange(e)}>
              <FormControlLabel value="Snap" control={<Radio />} label="Snap" disabled={shouldDisabledSnap} />
              <FormControlLabel value="Third Party" control={<Radio />} label="Third Party" />
            </RadioGroup>
            {!!error && <FormHelperText>{error}</FormHelperText>}
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  )
});

export default PreferredProcessContent;